<script>
    export let title ='def';
</script>

<div class="main-title">
    <h2>{title}</h2>
</div>